
import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog} from "primereact";
import { TabPanel, TabView } from "primereact/tabview";

import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";


import { UsuariosConAcceso } from "../../../API/IT/Accesos/AccesosRequests";

const AccesosUser = ({
  showDialogUser,
  setShowDialogUser,
  selected,
}) => {
    
  const { config } = useContext(ConfigContext);
  const [userAccess, setUserAccess] = useState([]);
  const [rolAccess, setRolAccess] = useState([]);
  const [loading, setLoading] = useState(false);


  const hideDialog = () => {
    setShowDialogUser(false);
  };

  const getInfo = async () => {
    setLoading(true);
    const result = await UsuariosConAcceso(selected?.IdAcceso);
    setUserAccess(result);
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
  }, [showDialogUser]);


  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "idUser",
      className: "Xsmall",
    },
    {
      header: "Nombre",
      headerEn: "Name",
      field: "UserName",
      flex: 1,
    },
    {
      header: "Usuario",
      headerEn: "User",
      field: "Usuario",
    },
    {
      header: "Rol",
      headerEn: "Rol",
      field: "Rol",
    },
    {
      header: "Código Personal",
      headerEn: "Personal Code",
      field: "idPersonal",
    },
  ];

const table = {
    Columns: columns,
    Data: userAccess,
    loading: loading,
  };


  return (
    <div>
      <Dialog
        visible={showDialogUser}
        style={{ width: "50vw", height: "65vh" }}
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        onHide={hideDialog}
      >
          <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h3 style={{ marginRight: "1rem" }}>
            {getLabel(baseLang, "userAccess", config.language)}{" "}
            {selected?.Acceso}
          </h3>
          <Button icon="pi pi-refresh" onClick={getInfo} />
        </div>


        <TabView>
          <TabPanel header="Usuarios con Acceso">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            ></div>
            <div style={{ height: "50vh" }}>
              <AgGrid table={table} />
            </div>
          </TabPanel>
        </TabView>
      </Dialog>
    </div>
  );
};


export default AccesosUser;
